var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-setup"},[(_vm.loading)?_c('b-spinner',{attrs:{"variant":"success"}}):_c('div',[_c('span',{staticClass:"btn btn-download",on:{"click":_vm.getUserInviteList}},[_vm._v("Aicināmo lietotāju saraksts")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }